var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import * as baobab from '@data/baobab/baobab';
import { evaluatorApi } from '@data/rest/api';
export function useSingleValueData(wConfig, wId, tagSlicerFilter) {
    var accountTags = wConfig.accountTags, filterTags = wConfig.filterTags, comparisonTags = wConfig.comparisonTags;
    var _a = __read(useState([null, null]), 2), values = _a[0], setValues = _a[1];
    useEffect(function () {
        function evaluateTags() {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter(this, void 0, void 0, function () {
                var orFilters, evaluateResult, e_1;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            baobab.root.select('state', 'widgetsLoading', wId).set(true);
                            _g.label = 1;
                        case 1:
                            _g.trys.push([1, 3, , 4]);
                            orFilters = Object.values(tagSlicerFilter).filter(function (f) { return (f === null || f === void 0 ? void 0 : f.length) > 0; });
                            return [4 /*yield*/, evaluatorApi.evaluate({
                                    rows: [
                                        getExpression(filterTags, { useOrFilters: wConfig.useTagSlicers, orFilters: orFilters }),
                                        getExpression(comparisonTags, { useOrFilters: wConfig.useTagSlicers, orFilters: orFilters }),
                                    ],
                                    cols: [getExpression(accountTags)],
                                })];
                        case 2:
                            evaluateResult = _g.sent();
                            setValues([(_c = (_b = (_a = evaluateResult === null || evaluateResult === void 0 ? void 0 : evaluateResult[0]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : null, (_f = (_e = (_d = evaluateResult === null || evaluateResult === void 0 ? void 0 : evaluateResult[1]) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : null]);
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _g.sent();
                            toast.error('Error loading single value data.');
                            setValues([null, null]);
                            return [3 /*break*/, 4];
                        case 4:
                            baobab.root.select('state', 'widgetsLoading', wId).set(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (accountTags.length === 0) {
            setValues([null, null]);
        }
        else {
            evaluateTags();
        }
    }, [accountTags, filterTags, comparisonTags, tagSlicerFilter, wConfig.useTagSlicers]);
    return values;
}
function getExpression(filterTagIds, options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.orFilters) === null || _a === void 0 ? void 0 : _a.length) && (options === null || options === void 0 ? void 0 : options.useOrFilters)
        ? "tags(".concat(filterTagIds.join(','), ", ").concat(options.orFilters.map(function (f) { return f.join('|'); }).join(','), ")")
        : "tags(".concat(filterTagIds.join(','), ")");
}
